import { c as _c } from "react/compiler-runtime";
import { prettyStatusLabel, uploadItemShowsLoader, type UploadStatus } from "@shared-components/upload/file-upload-provider";
import { ListItem } from "@shared-components/list-item";
import { Badge } from "@shared-components/shadcn/badge";
import { Popover, PopoverContent, PopoverTrigger } from "@shared-components/shadcn/popover";
import { CloudUpload, RefreshCw } from "lucide-react";
import { Button } from "./shadcn/button";
import _ from "lodash";
import { useFileUploadStatus } from "./upload/use-file-upload-status";
export const getBadgeFromUploadStatus = (status: UploadStatus, progress?: number | null) => {
  const statusLabel = prettyStatusLabel(status);
  const showProgress = progress != null && progress > 0 && progress < 100;
  switch (status) {
    case "creatingMetadata":
    case "metadataCreated":
    case "uploading":
    case "uploadCompleted":
    case "processing":
    case "indexing":
      return <Badge variant={"yellow"}>
          {showProgress ? `${statusLabel} ${progress}%` : statusLabel}
        </Badge>;
    case "analyzing":
      return <Badge variant={"blue"}>
          {showProgress ? `${statusLabel} ${progress}%` : statusLabel}
        </Badge>;
    case "completed":
      return <Badge variant={"green"}> {statusLabel} </Badge>;
    case "error":
      return <Badge variant={"red"}> {statusLabel} </Badge>;
    case "pending":
    case "removed":
      return <Badge variant={"secondary"}> {statusLabel} </Badge>;
  }
};
export const FileUploadStatusPopover = () => {
  const $ = _c(29);
  const {
    items
  } = useFileUploadStatus();
  let T0;
  let T1;
  let t0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== items) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const filteredItems = items.filter(_temp);
      if (filteredItems.length === 0) {
        t6 = null;
        break bb0;
      }
      const hasActiveUploads = items.some(_temp2);
      T1 = Popover;
      let t7;
      if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
        t7 = <CloudUpload />;
        $[10] = t7;
      } else {
        t7 = $[10];
      }
      let t8;
      if ($[11] !== hasActiveUploads) {
        t8 = hasActiveUploads && <div className="bg-ter-blue-500  w-4 h-4 rounded-full flex items-center justify-center absolute -top-1 -right-1 "><RefreshCw className="animate-spin stroke-background" size={10} strokeWidth={2} /></div>;
        $[11] = hasActiveUploads;
        $[12] = t8;
      } else {
        t8 = $[12];
      }
      if ($[13] !== t8) {
        t5 = <PopoverTrigger asChild={true} className="relative"><Button variant="ghost" className="relative px-2"><div className="relative">{t7}{t8}</div></Button></PopoverTrigger>;
        $[13] = t8;
        $[14] = t5;
      } else {
        t5 = $[14];
      }
      T0 = PopoverContent;
      t2 = "end";
      t3 = "flex flex-col p-0 w-[300px] max-h-[500px]";
      if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t4 = <div className="p-2"><h4>{"Upload status"}</h4></div>;
        $[15] = t4;
      } else {
        t4 = $[15];
      }
      t0 = "overflow-y-auto";
      t1 = filteredItems.map(_temp3);
    }
    $[0] = items;
    $[1] = T0;
    $[2] = T1;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    T0 = $[1];
    T1 = $[2];
    t0 = $[3];
    t1 = $[4];
    t2 = $[5];
    t3 = $[6];
    t4 = $[7];
    t5 = $[8];
    t6 = $[9];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  let t7;
  if ($[16] !== t0 || $[17] !== t1) {
    t7 = <div className={t0}>{t1}</div>;
    $[16] = t0;
    $[17] = t1;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== T0 || $[20] !== t2 || $[21] !== t3 || $[22] !== t4 || $[23] !== t7) {
    t8 = <T0 align={t2} className={t3}>{t4}{t7}</T0>;
    $[19] = T0;
    $[20] = t2;
    $[21] = t3;
    $[22] = t4;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  let t9;
  if ($[25] !== T1 || $[26] !== t5 || $[27] !== t8) {
    t9 = <T1>{t5}{t8}</T1>;
    $[25] = T1;
    $[26] = t5;
    $[27] = t8;
    $[28] = t9;
  } else {
    t9 = $[28];
  }
  return t9;
};
function _temp(item) {
  return item.status !== "removed";
}
function _temp2(item_0) {
  return uploadItemShowsLoader(item_0.status);
}
function _temp3(item_1) {
  return <ListItem key={item_1.key} className="whitespace-nowrap flex flex-1 justify-between item-center gap-1"><span className="truncate">{item_1.file?.name}</span>{getBadgeFromUploadStatus(item_1.status, item_1.progress)}</ListItem>;
}